<template>
  <div class="cover-inpainting">
    <!-- Ретушь (inpainting/*) — только админу: для автора бэкенд отдаёт 403, остаётся только «Сохранить» -->
    <image-inpainting-editor
        ref="editor"
        :image-url="album.cover"
        @result="resultImageUrl = $event"
        @processing="isProcessing = $event"
    />

    <div class="mt-1">
      <span v-if="album.release_date" class="text-muted">{{ album.release_date }}</span>
    </div>

    <div class="mt-1 d-flex align-items-center" style="gap: 0.5rem;">
      <label class="mb-0 font-small-3">Сложность:</label>
      <b-form-rating
          v-model="coverDifficulty"
          :stars="5"
          inline
          no-border
          size="sm"
          variant="warning"
          class="p-0"
      />
    </div>

    <div class="mt-1 d-flex" style="gap: 0.5rem;">
      <b-button
          v-if="hasResult && $can('manage', 'all')"
          variant="outline-secondary"
          @click="resetToOriginal"
      >
        <feather-icon icon="RotateCcwIcon" class="mr-50" />
        Вернуть оригинал
      </b-button>
      <b-button
          variant="success"
          :disabled="isSaving || isProcessing"
          @click="handleSave"
      >
        <b-spinner v-if="isSaving" small class="mr-50" />
        <feather-icon v-else icon="DownloadIcon" class="mr-50" />
        <span class="align-middle">{{ isSaving ? 'Сохранение...' : 'Сохранить' }}</span>
      </b-button>
    </div>
  </div>
</template>

<script>
import { ref, computed, watch } from '@vue/composition-api'
import { BButton, BSpinner, BFormRating } from 'bootstrap-vue'
import ImageInpaintingEditor from '@/views/db-music/ImageInpaintingEditor.vue'

export default {
  components: {
    BButton,
    BSpinner,
    BFormRating,
    ImageInpaintingEditor,
  },
  props: {
    album: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const editor = ref(null)
    const isProcessing = ref(false)
    const isSaving = ref(false)
    const resultImageUrl = ref(null)
    const coverDifficulty = ref(0)

    const currentImageUrl = computed(() => resultImageUrl.value || props.album.cover)
    const hasResult = computed(() => !!resultImageUrl.value)

    function resetToOriginal() {
      editor.value.resetToOriginal()
    }

    function handleSave() {
      isSaving.value = true
      emit('save', currentImageUrl.value, () => {
        isSaving.value = false
      }, coverDifficulty.value)
    }

    // Смена альбома — сброс ретуши, даже если у альбомов одинаковая обложка
    watch(() => props.album, () => {
      coverDifficulty.value = 0
      if (editor.value) editor.value.resetState()
    })

    return {
      editor,
      isProcessing,
      isSaving,
      resultImageUrl,
      coverDifficulty,
      hasResult,
      resetToOriginal,
      handleSave,
    }
  },
}
</script>
